import { SvgIcon } from "@material-ui/core";
import React from "react";


export function EposLogo(props: any): JSX.Element {
    console.log(props);
    return (
        <SvgIcon {...props} fill='none'>
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.5006 0.999939C15.7471 0.999939 20 5.25275 20 10.4999C20 15.7471 15.7471 19.9999 10.5006 19.9999C5.25403 19.9999 1 15.7471 1 10.4999C1 5.25275 5.25403 0.999939 10.5006 0.999939Z" stroke="rgba(0, 0, 0, 0.54)" strokeWidth="1.5" />
                <path fillRule="evenodd" clipRule="evenodd" d="M12.9265 9.64712C13.4115 9.62594 13.8718 9.69394 14.2895 9.83552L9.78733 13.9367C9.60994 13.5845 9.51226 13.1921 9.51226 12.7751C9.51226 11.1298 11.0414 9.7285 12.9265 9.64712ZM13.1398 7.54245C14.9294 7.54245 16.5248 8.34396 17.569 9.59696L10.8831 15.6769C12.5324 17.184 16.5293 16.7994 16.8482 12.1899L18.749 12.1074C18.8051 12.4206 18.8354 12.7428 18.8354 13.0717C18.8354 16.125 16.2846 18.6009 13.1398 18.6009C9.99504 18.6009 7.44531 16.125 7.44531 13.0717C7.44419 10.0183 9.99504 7.54245 13.1398 7.54245Z" fill="rgba(0, 0, 0, 0.54)" />
            </svg>
        </SvgIcon>
    )
}